import { Component, Output } from '@angular/core';
import { Client } from './models/clients/client';
import { AUTH } from './contants/AUTH';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'app';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts